import React from 'react'
import { from } from 'rxjs'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import connect from 'front-end-core/decorators/connect'
import { requestFlavouredQASections } from 'services/QAService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import QAMenu from './Main'
import { get } from 'libraries/lodash'

const ConnectedQAMenu = connect((props) => ({
  qaSections: props.aol ? requestFlavouredQASections(props.aol, get(props, 'pageParameters.flavours', [])) : from(RESPONSE_PENDING)
}))((props) => (
  <ResponseConsumer response={props.qaSections} skeleton='tiled-menu' content={() => <QAMenu {...props} />} />
))

export default ConnectedQAMenu
